export const ticketUpdateErrorMessage = (error, translate) => {
  const response = error?.response;
  const payload = response?.data || {};
  const errors = payload.errors;
  const messages = Array.isArray(errors) ? errors : [errors];
  const details = messages
    .filter(message => typeof message === 'string' && message.trim())
    .join(' ');

  if (details) return details;
  if (typeof payload.error === 'string' && payload.error.trim()) {
    return payload.error;
  }
  if (typeof payload.message === 'string' && payload.message.trim()) {
    return payload.message;
  }
  if (response?.status) {
    return translate('TICKET_DETAILS.ERROR_UPDATE_TICKET_HTTP', {
      status: response.status,
    });
  }

  return translate('TICKET_DETAILS.ERROR_UPDATE_TICKET');
};
